import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppShell } from "./pages/AppShell";

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <AppShell />
  </StrictMode>
);

createRoot(elem).render(app);
